import { render } from "./DonateOrderDetail.vue?vue&type=template&id=3e8d49d0"
import script from "./DonateOrderDetail.vue?vue&type=script&lang=js"
export * from "./DonateOrderDetail.vue?vue&type=script&lang=js"
script.render = render

export default script